function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./pause-modal.scss";
import template from "./pause-modal.html";

export var PauseModalComponent = {
  template: template,
  bindings: {
    onClose: "&" },

  controller: /*#__PURE__*/function () {PauseModalComponentController.$inject = ["LayoutService", "$scope", "$timeout"];
    function PauseModalComponentController(LayoutService, $scope, $timeout) {
      "ngInject";_classCallCheck(this, PauseModalComponentController);
      this.LayoutService = LayoutService;
      console.log(this);
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.animateOnShow = true;
    }_createClass(PauseModalComponentController, [{ key: "$onInit", value: function $onInit()

      {
      } }, { key: "$onChanges", value: function $onChanges()

      {} }, { key: "$postLink", value: function $postLink()

      {var _this = this;
        Promise.resolve().
        then(function () {
          _this.$timeout(function () {
            _this.animateOnShow = true;
          }, 300);
        }).
        then(function () {
          _this.$timeout(function () {
            _this.onShow();
          }, 400);
        });
      } }, { key: "$onDestroy", value: function $onDestroy()

      {
        this.onClose();
      } }]);return PauseModalComponentController;}() };